<template>
  <div class="search--template page-template page page-transition bg-beige">
    <!-- CONTENT -->
    <div class="relative container-fluid z-content">
      <section class="relative center w-100 pt2 pt4-ns pb3 pb5-ns z-content">
        <div class="relative center">
          <div class="relative center mv4 pv4 ph4 bg-navy">
            <form class="relative search-form" onsubmit="return false;">
              <div>
                <input class="dib w-100 search-input-css bb--is-beige-1px f4 is-tablet-regular is-beige z-1" type="text" id="search" name="search" required placeholder=" " v-model="query" />
                <label class="f4 search label is-beige" for="search">[search term here]</label>
                <a class="db absolute right-0 nt4" @click=""><img class="db relative w2" src="/assets/images/svg-icons/search-icon-beige.svg" /></a>
                <label for="email" class="f4 f4-ns tc is-black z--1">eg. Lineup, tickets</label>
              </div>
            </form>
          </div>
          <div v-if="query == null || query === '' || query === ' '" class="">
            <div class="f3 mv3 vh-50 tl lh-title is-tablet-regular is-black">
              Please enter something to search such as <router-link :to="'/search/?search=tickets'" class="is-orange link pointer" title="tickets">tickets</router-link> or <router-link :to="'/search/?search=news'" class="is-orange link pointer" title="news">news</router-link>
            </div>
          </div>
          <div v-else class="w-100">
            <div class="relative">
              <div v-if="queryResults.length == 0" class="relative">
                <div class="f3 mv3 tl">
                  <p>
                    Please try a different search, such as <router-link :to="'/search/?search=lineup'" class="is-orange link pointer" title="lineup">lineup</router-link> or <router-link :to="'/search/?search=tickets'" class="is-orange link pointer" title="tickets">tickets</router-link>.
                  </p>
                </div>
              </div>
              <div v-else class="relative pt0 pt3-ns">
                <div class="row">
                  <div class="col-xs-12 col-sm-4 mv3 mv4-ns" v-for="(result, index) of queryResults" :key="'search-result-' + index">
                    <router-link class="db relative no-underline hover-text-h is-black link pointer" :to="result.url" :title="result.title">
                      <h3 class="db f2 mv3 tl no-underline ttn is-tablet-bold is-navy">{{ result.title }}</h3>
                      <p v-if="result.excerpt" class="is-tablet-regular is-black mv2 lh-copy">
                        {{ result.excerpt | truncate(140, '...') }}
                      </p>
                      <router-link class="db mv3 no-underline pointer link" :to="result.url">
                        <h5 class="f4 is-tablet-regular ttu is-black text">
                          Read More
                        </h5>
                      </router-link>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 
          <div class="" v-html="page.content">
            queryResults.length: {{ queryResults.length }}
            queryResults: {{ queryResults }}
          </div> 
        -->
      </section>
    </div>
  </div>
</template>
<script>
import fz from 'fuzzaldrin-plus';
export default {
  props: {
    pageMarkdownFileName: {
      //
    }
  },
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      //query: '',
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      resultsLoading: true,
      query: this.$route.query.search,
      options: this.$store.state.data,
      searchResultsAreVisible: false,
      searchSubmission: {
        query: ''
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.scrollBg);
  },
  mounted() {
    //
    //console.log('this.query: ', this.query); 
  },
  computed: {
    optionsFiltered: function() {
      var optionsAll = this.options;
      var optionsFiltered = optionsAll.filter(function(item) {
        if (item.title != undefined) {
          if (item.name === 'content.markdown' || 
              item.name === 'footer.markdown' || 
              item.name === 'main-navigation.markdown' || 
              item.name === 'page-not-found.markdown'|| 
              item.name === 'search-results.markdown' || 
              item.name === 'search.markdown' || 
              item.name === 'feed.xml' || 
              item.name === 'index.markdown'
          ) {}
          else {
            //console.log('item:', item.title);
            return item;
          }
        }
        /*
        optionsAll.forEach(function(item) {
        if (item.name != 'content.markdown')
          console.log('item:', item.name);
          return item;
        });
        */
      });
      return optionsFiltered;
    },
    queryResults() {
      if (this.query != '' || this.query != undefined) {

        if(!this.query) return this.optionsFiltered;

        const preparedQuery = fz.prepareQuery(this.query);
        const scores = {};

        return this.optionsFiltered
          .map((option, index) => {
            const scorableFields = [
              option.title,
              option.seo_title,
              option.seo_description,
              option.excerpt
              //option.content
            ].map(toScore => fz.score(toScore, this.query, { preparedQuery }));

            scores[option.title] = Math.max(...scorableFields);

            return option;
          })
          .filter(option => scores[option.title] > 1)
          .sort((a, b) => scores[b.title] - scores[a.title])
        ;
      }
      else {
        //this.searchResultsAreVisible = false;
      }
    },
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('search.markdown');
      return pageData[0];
    }
  },
  filters: {
    //
  },
  methods : {
    submitSearch() {
      console.log('1.1 - submitSearch - ', this.searchSubmission.query );

      var searchQuery = this.searchSubmission.query.toLowerCase();

      //this.searchBarIconIsClicked = false;
      bus.$emit('searchBarIsSubmitBus');

      console.log('1.2 - submitSearch - ', searchQuery);

      this.$router.push(
        { 
          path: '/search/', 
          query: { 
            search: searchQuery
          } 
        }
      )
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollBg);
  }
}
</script>